import React from "react";
import { IconButton, Grid } from "@material-ui/core";
import FilterIcon from "@material-ui/icons/FilterListOutlined";
import { DisplayDrawerContext } from "../../../layout/DisplayDrawerContext";
import { useExchangeMembersReportFilter } from "../../../data/reports/exmember/hooks/useExchangeMembersReportFilter";
import { LocalizationContext } from "../../../core/localization/Localization";
import { CustomTooltip } from "../../components/common/CustomTooltip";
import { ExchangeMembersFilterEditor } from "./ExchangeMembersFilterEditor";

export const ExchangeMemberReportFilter: React.FunctionComponent = () => {
  const showWithDrawer = React.useContext(DisplayDrawerContext);
  const showFilter = React.useCallback(
    () => showWithDrawer(<ExchangeMemberFilterEditor />),
    [showWithDrawer]
  );

  const [filter, editfilter, save] = useExchangeMembersReportFilter();
  const { getString } = React.useContext(LocalizationContext);

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item>
        <CustomTooltip titleKeyword="filterTooltip">
          <IconButton color="secondary" component="span" onClick={showFilter}>
            <FilterIcon />
          </IconButton>
        </CustomTooltip>
      </Grid>
    </Grid>
  );
};

const ExchangeMemberFilterEditor: React.FunctionComponent = () => {
  const [filter, editFilter, save] = useExchangeMembersReportFilter();
  return (
    <ExchangeMembersFilterEditor
      filter={filter}
      editFilter={editFilter}
      save={save}
    />
  );
};
